export enum DIContainerKeys {
  ReduxStore = 'reduxStore',
  AuthService = 'AuthService',
  MspInviteService = 'MspInviteService',
  MspDetailsService = 'MspDetailsService',
  CountriesService = 'CountriesService',
  PortlandReportService = 'PortlandReportService',
  NetworkAccessService = 'NetworkAccessService',
  ProductService = 'ProductService',
  MembersAccessService = 'MembersAccessService',
  ColorPaletteService = 'ColorPaletteService',
  TagsService = 'TagsService',
  EmailTemplatesService = 'EmailTemplatesService',
  PlanService = 'PlanService',
  MemberDetailsService = 'MemberDetailsService',
  AccessRolesDetailsService = 'AccessRolesDetailsService',
  ClientAccessRolesDetailsService = 'ClientAccessRolesDetailsService',
  CompanySettingsService = 'CompanySettingsService',
  ToolInfoService = 'ToolInfoService',
  PracticeService = 'PracticeService',
  SecurityStackHeaderViewService = 'SecurityStackHeaderViewService',
  SecurityStackViewService = 'SecurityStackViewService',
  TechnologiesByToolService = 'TechnologiesByToolService',
  ToolService = 'ToolService',
  CategoryProductsService = 'CategoryProductsService',
  StorefrontProductsService = 'StorefrontProductsService',
  CategoryService = 'CategoryService',
  CategorySortOrderService = 'CategorySortOrderService',
  CompanyTechSpendService = 'CompanyTechSpendService',
  SuppliersAndManufacturersService = 'SuppliersAndManufacturersService',
  RecalculateScoreService = 'RecalculateScoreService',
  SubscriptionService = 'SubscriptionService',
}
